module.exports = __webpack_public_path__ + "img/guanyu_fenlie@2x.db3acd7a.png";